// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Transactions_main__0eWYA {
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  gap: 2rem;
}
.Transactions_main_nav__TRDxv {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 2rem;
  padding: 0 2rem;
  background-color: var(--color-white);
  border-bottom: solid 1px var(--color-dark);
  border-radius: 1rem 1rem 0 0;
}
.Transactions_main_nav__TRDxv > :not(:last-child) {
  margin-right: 1rem;
}
.Transactions_main_nav_group__8Po1l {
  position: relative;
}
.Transactions_main_nav_more__HXbHd {
  position: absolute;
  right: 0;
  top: 75%;
  background-color: var(--color-white);
  padding: 1.5rem;
  border-radius: 1rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  z-index: 5;
}
.Transactions_main_nav_more__HXbHd > :not(last-child) {
  margin-bottom: 1rem;
}
.Transactions_main_nav_item__C7pbQ {
  cursor: pointer;
  padding: 1rem 0;
  box-sizing: border-box;
  font-size: var(--default-font-small);
}
.Transactions_main_nav_item_active__VecMV {
  cursor: pointer;
  padding: 1rem 0;
  box-sizing: border-box;
  font-size: var(--default-font-small);
  font-weight: 700;
  color: var(--color-fash-primary-3);
  border-bottom: solid 2px var(--color-fash-primary-3);
}
.Transactions_main_nav_item__C7pbQ:hover, .Transactions_main_nav_item__C7pbQ:focus, .Transactions_main_nav_item__C7pbQ:focus-visible, .Transactions_main_nav_item__C7pbQ:focus-within {
  font-weight: 700;
  color: var(--color-fash-primary-3);
  border-bottom: solid 2px var(--color-fash-primary-3);
}

.Transactions_searchInMiddle__c6yJF {
  margin-top: 3rem;
  grid-column: 1/3;
  display: flex;
  width: 100%;
  justify-content: center;
}

.Transactions_recent__\\+uJUo {
  display: grid;
  grid-template-columns: 1fr;
  width: 100%;
  grid-column: 1/3;
  margin-top: 3rem;
}
.Transactions_recent__title__tWoPF {
  display: grid;
  width: 100%;
  grid-template-columns: repeat(3, 1fr);
  border-radius: 1rem;
  background-color: var(--color-primary-3);
  font-size: var(--default-font-small);
}
.Transactions_recent__title__active__WW6pA {
  background-color: var(--color-dark);
  color: var(--color-white);
  font-weight: 700;
}
.Transactions_recent__title__tWoPF > * {
  padding: 1rem 0;
  text-align: center;
  box-sizing: border-box;
  cursor: pointer;
}
@media only screen and (max-width: 37.5em) {
  .Transactions_recent__title__tWoPF > * {
    text-align: center;
    padding: 1rem;
  }
}
.Transactions_recent__title__tWoPF > *:hover {
  background-color: var(--color-dark);
  color: var(--color-white);
  font-weight: 700;
}
.Transactions_recent__title__tWoPF > :not(:last-child) {
  border-right: 1px solid var(--color-primary);
}
.Transactions_recent__title__tWoPF > :first-child {
  border-radius: 1rem 0 0 1rem;
}
.Transactions_recent__title__tWoPF > :last-child {
  border-radius: 0 1rem 1rem 0;
}

.Transactions_date__AR2ZR {
  background: var(--color-dark);
  border-radius: 1rem;
  padding: 1rem;
  text-align: center;
  font-weight: 700;
  font-size: var(--default-font-small);
  line-height: 1.7rem;
  color: var(--color-white);
  margin-top: 2rem;
  margin-bottom: 2rem;
}

.Transactions_rt__main__8h1hC {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.Transactions_rt__content__OylBj {
  width: 95%;
  cursor: pointer;
}
.Transactions_rt__content__OylBj > :not(:last-child) {
  margin-bottom: 3rem;
}

.Transactions_paymentType__konyh {
  display: flex;
  flex-direction: row;
  gap: 2.9rem;
  margin-right: 2rem;
  margin-bottom: 2rem;
}

.Transactions_beside__sh6vD {
  display: flex;
  justify-content: space-between;
  width: 38rem;
}

.Transactions_successImg__ksTU1 {
  height: 19rem;
}

.Transactions_error__NPbqG {
  font-size: var(--default-font-small);
  color: var(--color-error);
  font-weight: 400;
}

.Transactions_checks__mnsLT {
  display: flex;
  justify-content: space-between;
  margin: 1rem 0 2rem 0;
  gap: 7rem;
  width: 40rem;
}

.Transactions_incomeTable__kJPzn {
  margin-top: 2rem;
}
.Transactions_incomeTable__kJPzn table {
  width: 100%;
  max-width: 100%;
  border: none;
  border-collapse: collapse;
  box-sizing: border-box;
  text-align: left;
  font-size: var(--default-font-small);
}
.Transactions_incomeTable__kJPzn table th,
.Transactions_incomeTable__kJPzn table td {
  padding: 2.2rem 0;
}
.Transactions_incomeTable__kJPzn table th {
  font-weight: 700;
}
.Transactions_incomeTable__kJPzn table tr {
  display: grid;
  grid-template-columns: 1fr 2.5fr repeat(4, 1fr) 0.5fr;
  padding: 0 1.5rem;
}
@media only screen and (max-width: 37.5em) {
  .Transactions_incomeTable__kJPzn table tr {
    grid-template-columns: 1.5fr 2.5fr 1fr;
  }
}
.Transactions_incomeTable__kJPzn table tbody > :not(:last-child) {
  margin-bottom: 1.5rem;
}
.Transactions_incomeTable__kJPzn table tbody tr {
  background-color: var(--color-primary-3);
  cursor: pointer;
  border-radius: 1.3rem;
}
.Transactions_incomeTable__kJPzn table tbody tr:nth-child(even) {
  background-color: var(--color-primary-7);
}
.Transactions_incomeTable__kJPzn table tbody tr > :nth-child(7) {
  font-size: 3rem;
  position: relative;
}
.Transactions_incomeTable__kJPzn table tbody tr > :nth-child(7) span {
  font-size: 1.2rem;
  width: -moz-fit-content;
  width: fit-content;
  background-color: rgba(0, 0, 0, 0.75);
  color: var(--color-white);
  position: absolute;
  padding: 0.5rem;
  left: -1.6rem;
  border-radius: 0.5rem;
  text-align: center;
  opacity: 0;
  cursor: pointer;
}
.Transactions_incomeTable__kJPzn table tbody tr > :nth-child(7) span:hover {
  opacity: 1;
}

.Transactions_expenseTable__EvhQv {
  margin-top: 2rem;
}
.Transactions_expenseTable__EvhQv table {
  width: 100%;
  border: none;
  border-collapse: collapse;
  box-sizing: border-box;
  text-align: left;
  font-size: var(--default-font-small);
}
.Transactions_expenseTable__EvhQv table th,
.Transactions_expenseTable__EvhQv table td {
  padding: 2.2rem 0;
}
.Transactions_expenseTable__EvhQv table th {
  font-weight: 700;
}
.Transactions_expenseTable__EvhQv table tr {
  display: grid;
  grid-template-columns: repeat(6, 1fr) 0.5fr;
  padding: 0 3rem;
}
@media only screen and (max-width: 37.5em) {
  .Transactions_expenseTable__EvhQv table tr {
    grid-template-columns: 1.5fr 2fr 2fr;
  }
}
.Transactions_expenseTable__EvhQv table tbody > :not(:last-child) {
  margin-bottom: 1.5rem;
}
.Transactions_expenseTable__EvhQv table tbody tr {
  background-color: var(--color-primary-3);
  cursor: pointer;
  border-radius: 1.3rem;
}
.Transactions_expenseTable__EvhQv table tbody tr:nth-child(even) {
  background-color: var(--color-primary-7);
}
.Transactions_expenseTable__EvhQv table tbody tr > :nth-child(7) {
  font-size: 3rem;
  position: relative;
}
.Transactions_expenseTable__EvhQv table tbody tr > :nth-child(7) span {
  font-size: 1.2rem;
  width: -moz-fit-content;
  width: fit-content;
  background-color: rgba(0, 0, 0, 0.75);
  color: var(--color-white);
  position: absolute;
  padding: 0.5rem;
  left: -1.6rem;
  border-radius: 0.5rem;
  text-align: center;
  opacity: 0;
  cursor: pointer;
}
.Transactions_expenseTable__EvhQv table tbody tr > :nth-child(7) span:hover {
  opacity: 1;
}

.Transactions_expenseDebtTable__d08Tl {
  margin-top: 2rem;
}
.Transactions_expenseDebtTable__d08Tl table {
  width: 100%;
  max-width: 100%;
  border: none;
  border-collapse: collapse;
  box-sizing: border-box;
  text-align: left;
  font-size: var(--default-font-small);
  position: relative;
}
.Transactions_expenseDebtTable__d08Tl table th,
.Transactions_expenseDebtTable__d08Tl table td {
  padding: 2.2rem 0;
}
.Transactions_expenseDebtTable__d08Tl table th {
  font-weight: 700;
}
.Transactions_expenseDebtTable__d08Tl table tr {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  padding: 0 3rem;
  align-items: center;
}
.Transactions_expenseDebtTable__d08Tl table tbody > :not(:last-child) {
  margin-bottom: 1.5rem;
}
.Transactions_expenseDebtTable__d08Tl table tbody tr {
  background-color: var(--color-primary-3);
  cursor: pointer;
  border-radius: 1.3rem;
}
.Transactions_expenseDebtTable__d08Tl table tbody tr:nth-child(even) {
  background-color: var(--color-primary-7);
}

.Transactions_notPaid__h3MB5 {
  display: inline-flex;
  justify-content: center;
  line-height: 1;
  font-size: 1rem;
  border-radius: 1rem;
  background-color: var(--color-error);
  color: var(--color-white);
  margin: 1.5rem 0;
  width: 83%;
  text-align: center;
  padding: 1rem;
}

.Transactions_partPaid__YM64h {
  display: inline-flex;
  justify-content: center;
  line-height: 1;
  font-size: 1rem;
  border-radius: 1rem;
  background-color: var(--color-yellow);
  color: var(--color-dark);
  margin: 1.5rem 0;
  width: 83%;
  text-align: center;
  padding: 1rem;
}

.Transactions_paid__blUp\\+ {
  display: inline-flex;
  justify-content: center;
  line-height: 1;
  font-size: 1rem;
  border-radius: 1rem;
  background-color: var(--color-green);
  color: var(--color-white);
  margin-bottom: 2rem;
  width: 83%;
  position: relative;
  top: 1rem;
  padding: 1rem;
}

.Transactions_alignRight__kx--b {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  font-size: var(--default-font-small);
  color: var(--color-primary);
  cursor: pointer;
  font-weight: 700;
  text-decoration: underline;
}

.Transactions_tableButton__J36rR {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: var(--color-white);
  font-size: 2rem;
  width: 34rem;
  height: 5.7rem;
  padding: 2rem;
  background-color: var(--color-primary);
  border-radius: 1rem;
  cursor: pointer;
  z-index: 1000;
}
.Transactions_tableButton_active__M1PO2 {
  transform: rotate(180deg);
  z-index: 10000;
}

.Transactions_dropDown__\\+ng9P {
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: var(--color-white);
  font-size: 2rem;
  box-sizing: border-box;
  border-bottom: 1px solid var(--color-dark);
  padding: 1rem;
  width: 34rem;
  cursor: pointer;
  align-content: center;
}

.Transactions_receipt__list__T8YNV {
  margin-top: 2rem;
  display: flex;
  position: relative;
}
.Transactions_receipt__beside__VQWSk {
  display: flex;
  justify-content: space-between;
}
.Transactions_receipt__checks__a\\+nVp {
  display: flex;
  justify-content: space-between;
  margin: 1rem 0 2rem 0;
}

.Transactions_summary__lIo7k {
  width: 42rem;
  margin-top: 2rem;
}
.Transactions_summary__title__xIQc2 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.Transactions_summary__edit__8Eugp {
  display: flex;
  align-items: flex-end;
  color: var(--color-dark);
  font-size: var(--default-font-small);
  cursor: pointer;
}
.Transactions_summary__edit__8Eugp > :last-child {
  font-size: 3rem;
  color: var(--color-primary);
}
.Transactions_summary__edit__8Eugp:hover, .Transactions_summary__edit__8Eugp:focus {
  color: var(--color-primary-4);
  font-weight: 700;
}
.Transactions_summary__line__Xjekf {
  border-top: 1px solid var(--color-primary);
  margin: 2rem 0;
}
.Transactions_summary__beside__9W2l6 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.Transactions_summary__dates__QsV7m {
  display: flex;
  justify-content: space-between;
  margin-bottom: 2rem;
}
.Transactions_summary__dates__QsV7m > :not(:last-child) {
  margin-right: 2rem;
}
.Transactions_summary__details__tthZ8 {
  color: var(--color-primary);
}
.Transactions_summary__total__NeHCw {
  display: grid;
  grid-template-columns: 1.3fr 1fr;
  gap: 2rem;
  margin-bottom: 1rem;
}
.Transactions_summary__account__vGqGS {
  display: grid;
  grid-template-columns: 1.3fr 1fr;
  gap: 1rem;
  margin: 2rem 0;
}
.Transactions_summary__button__fcWZo {
  display: flex;
  gap: 2rem;
}

.Transactions_noRecord__5mGZ6 {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 75.5%;
  text-align: center;
}

.Transactions_txFilterSection__d2D-E {
  display: flex;
  gap: 2rem;
  margin-top: 2rem;
}

.Transactions_txSelect__GjgEc {
  width: 30rem;
  font-size: var(--default-font-small);
}
.Transactions_txSelect__title__JV8pz {
  width: 100%;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.9rem 2.2rem;
  background-color: var(--color-white);
  border-radius: 1rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  color: var(--color-fash-primary-3);
}
.Transactions_txSelect__title__JV8pz:hover {
  color: var(--color-fash-primary-3);
  background-color: var(--color-light-blue-2);
}
.Transactions_txSelect__title__icon__8P97\\+ {
  font-size: 2rem;
}
.Transactions_txSelect__content__Hx1rY {
  width: 100%;
  background-color: var(--color-white);
  border-radius: 1rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  padding: 0.9rem 0;
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  max-height: 20rem;
  overflow-y: scroll;
}
.Transactions_txSelect__content__Hx1rY span {
  padding: 1rem 2.2rem;
}
.Transactions_txSelect__content__Hx1rY span:hover, .Transactions_txSelect__content__Hx1rY span:active, .Transactions_txSelect__content__Hx1rY span:focus {
  background-color: var(--color-light-blue-2);
  color: var(--color-primary);
  font-weight: 700;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Transactions/Transactions.module.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,0BAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,SAAA;AAFF;AAYE;EACE,aAAA;EACA,8BAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EAEA,oCAAA;EACA,0CAAA;EACA,4BAAA;AAXJ;AAaI;EACE,kBAAA;AAXN;AAcI;EACE,kBAAA;AAZN;AAeI;EACE,kBAAA;EACA,QAAA;EACA,QAAA;EACA,oCAAA;EACA,eAAA;EACA,mBAAA;EACA,4CAAA;EACA,UAAA;AAbN;AAeM;EACE,mBAAA;AAbR;AAiBI;EACE,eAAA;EACA,eAAA;EACA,sBAAA;EACA,oCAAA;AAfN;AAqBM;EACE,eAAA;EACA,eAAA;EACA,sBAAA;EACA,oCAAA;EACA,gBAAA;EACA,kCAAA;EACA,oDAAA;AAnBR;AAsBM;EAIE,gBAAA;EACA,kCAAA;EACA,oDAAA;AAvBR;;AAkCA;EACE,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,WAAA;EACA,uBAAA;AA/BF;;AAoCA;EACE,aAAA;EACA,0BAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;AAjCF;AAmCE;EACE,aAAA;EACA,WAAA;EACA,qCAAA;EACA,mBAAA;EACA,wCAAA;EACA,oCAAA;AAjCJ;AAmCI;EACE,mCAAA;EACA,yBAAA;EACA,gBAAA;AAjCN;AAoCI;EACE,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AAlCN;AAoCM;EANF;IAOI,kBAAA;IACA,aAAA;EAjCN;AACF;AAmCM;EACE,mCAAA;EACA,yBAAA;EACA,gBAAA;AAjCR;AAqCI;EACE,4CAAA;AAnCN;AAsCI;EACE,4BAAA;AApCN;AAuCI;EACE,4BAAA;AArCN;;AA4CA;EACE,6BAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,oCAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;AAzCF;;AA+CE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AA5CJ;AA+CE;EACE,UAAA;EACA,eAAA;AA7CJ;AA+CI;EACE,mBAAA;AA7CN;;AAoDA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;AAjDF;;AAoDA;EACE,aAAA;EACA,8BAAA;EACA,YAAA;AAjDF;;AAoDA;EACE,aAAA;AAjDF;;AAsDA;EACE,oCAAA;EACA,yBAAA;EACA,gBAAA;AAnDF;;AAsDA;EACE,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,SAAA;EACA,YAAA;AAnDF;;AA0DA;EACE,gBAAA;AAvDF;AAyDE;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;EACA,oCAAA;AAvDJ;AAyDI;;EAEE,iBAAA;AAvDN;AA0DI;EACE,gBAAA;AAxDN;AA2DI;EACE,aAAA;EACA,qDAAA;EACA,iBAAA;AAzDN;AA2DM;EALF;IAMI,sCAAA;EAxDN;AACF;AA4DM;EACE,qBAAA;AA1DR;AA6DM;EACE,wCAAA;EACA,eAAA;EACA,qBAAA;AA3DR;AA6DQ;EACE,wCAAA;AA3DV;AA8DQ;EACE,eAAA;EACA,kBAAA;AA5DV;AA8DU;EACE,iBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,qCAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;AA5DZ;AA8DY;EACE,UAAA;AA5Dd;;AAqEA;EACE,gBAAA;AAlEF;AAoEE;EACE,WAAA;EAEA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;EACA,oCAAA;AAnEJ;AAqEI;;EAEE,iBAAA;AAnEN;AAsEI;EACE,gBAAA;AApEN;AAuEI;EACE,aAAA;EACA,2CAAA;EACA,eAAA;AArEN;AAuEM;EALF;IAMI,oCAAA;EApEN;AACF;AAwEM;EACE,qBAAA;AAtER;AAyEM;EACE,wCAAA;EACA,eAAA;EACA,qBAAA;AAvER;AAyEQ;EACE,wCAAA;AAvEV;AA0EQ;EACE,eAAA;EACA,kBAAA;AAxEV;AA0EU;EACE,iBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,qCAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;AAxEZ;AA0EY;EACE,UAAA;AAxEd;;AAiFA;EACE,gBAAA;AA9EF;AAgFE;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;EACA,oCAAA;EACA,kBAAA;AA9EJ;AAgFI;;EAEE,iBAAA;AA9EN;AAiFI;EACE,gBAAA;AA/EN;AAkFI;EACE,aAAA;EACA,qCAAA;EACA,eAAA;EACA,mBAAA;AAhFN;AAoFM;EACE,qBAAA;AAlFR;AAqFM;EACE,wCAAA;EACA,eAAA;EACA,qBAAA;AAnFR;AAqFQ;EACE,wCAAA;AAnFV;;AA0FA;EACE,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,oCAAA;EACA,yBAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;AAvFF;;AA0FA;EACE,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,qCAAA;EACA,wBAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;AAvFF;;AA0FA;EACE,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,oCAAA;EACA,yBAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;AAvFF;;AA0FA;EACE,WAAA;EACA,aAAA;EACA,yBAAA;EACA,oCAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;AAvFF;;AA0FA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,sCAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;AAvFF;AAyFE;EACE,yBAAA;EACA,cAAA;AAvFJ;;AA2FA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,oCAAA;EACA,eAAA;EACA,sBAAA;EACA,0CAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;AAxFF;;AA4FE;EACE,gBAAA;EACA,aAAA;EACA,kBAAA;AAzFJ;AA4FE;EACE,aAAA;EACA,8BAAA;AA1FJ;AA6FE;EACE,aAAA;EACA,8BAAA;EACA,qBAAA;AA3FJ;;AA+FA;EACE,YAAA;EACA,gBAAA;AA5FF;AA8FE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AA5FJ;AA+FE;EACE,aAAA;EACA,qBAAA;EACA,wBAAA;EACA,oCAAA;EACA,eAAA;AA7FJ;AA+FI;EACE,eAAA;EACA,2BAAA;AA7FN;AAgGI;EAEE,6BAAA;EACA,gBAAA;AA/FN;AAmGE;EACE,0CAAA;EACA,cAAA;AAjGJ;AAoGE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAlGJ;AAqGE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAnGJ;AAqGI;EACE,kBAAA;AAnGN;AAuGE;EACE,2BAAA;AArGJ;AAwGE;EACE,aAAA;EACA,gCAAA;EACA,SAAA;EACA,mBAAA;AAtGJ;AAyGE;EACE,aAAA;EACA,gCAAA;EACA,SAAA;EACA,cAAA;AAvGJ;AA0GE;EACE,aAAA;EACA,SAAA;AAxGJ;;AA4GA;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;AAzGF;;AA8GA;EACE,aAAA;EACA,SAAA;EACA,gBAAA;AA3GF;;AA8GA;EACE,YAAA;EACA,oCAAA;AA3GF;AA6GE;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EACA,oCAAA;EACA,mBAAA;EACA,4CAAA;EACA,eAAA;EACA,kCAAA;AA3GJ;AA6GI;EACE,kCAAA;EACA,2CAAA;AA3GN;AA8GI;EACE,eAAA;AA5GN;AAmHE;EACE,WAAA;EACA,oCAAA;EACA,mBAAA;EACA,4CAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;AAjHJ;AAmHI;EACE,oBAAA;AAjHN;AAmHM;EAGE,2CAAA;EACA,2BAAA;EACA,gBAAA;AAnHR","sourcesContent":["// styles for BusinessInsightCards and QuickCards//\n@import \"../variables/breakpoints\";\n\n.main {\n  display: grid;\n  grid-template-columns: 1fr;\n  align-items: center;\n  width: 100%;\n  box-sizing: border-box;\n  gap: 2rem;\n\n  // @media only screen and (max-width: $bp-1000) {\n  //   grid-template-columns: 56rem 1fr;\n  // }\n\n  // @media only screen and (max-width: $bp-700) {\n  //   grid-template-columns: 100%;\n  // }\n\n  &_nav {\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    margin-top: 2rem;\n    padding: 0 2rem;\n    // border-top: solid 1px var(--color-primary);\n    background-color: var(--color-white);\n    border-bottom: solid 1px var(--color-dark);\n    border-radius: 1rem 1rem 0 0;\n\n    & > :not(:last-child) {\n      margin-right: 1rem;\n    }\n\n    &_group {\n      position: relative;\n    }\n\n    &_more {\n      position: absolute;\n      right: 0;\n      top: 75%;\n      background-color: var(--color-white);\n      padding: 1.5rem;\n      border-radius: 1rem;\n      box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n      z-index: 5;\n\n      & > :not(last-child) {\n        margin-bottom: 1rem;\n      }\n    }\n\n    &_item {\n      cursor: pointer;\n      padding: 1rem 0;\n      box-sizing: border-box;\n      font-size: var(--default-font-small);\n\n      // @media only screen and (max-width: $bp-600) {\n      // \twidth: 47%;\n      // }\n\n      &_active {\n        cursor: pointer;\n        padding: 1rem 0;\n        box-sizing: border-box;\n        font-size: var(--default-font-small);\n        font-weight: 700;\n        color: var(--color-fash-primary-3);\n        border-bottom: solid 2px var(--color-fash-primary-3);\n      }\n\n      &:hover,\n      &:focus,\n      &:focus-visible,\n      &:focus-within {\n        font-weight: 700;\n        color: var(--color-fash-primary-3);\n        border-bottom: solid 2px var(--color-fash-primary-3);\n      }\n    }\n  }\n\n  // & > :nth-child(3) {\n  // \tgrid-column: 1/3;\n  // \tgrid-row: 2/3;\n  // }\n}\n\n.searchInMiddle {\n  margin-top: 3rem;\n  grid-column: 1/3;\n  display: flex;\n  width: 100%;\n  justify-content: center;\n}\n\n// styles for recent transactions //\n\n.recent {\n  display: grid;\n  grid-template-columns: 1fr;\n  width: 100%;\n  grid-column: 1/3;\n  margin-top: 3rem;\n\n  &__title {\n    display: grid;\n    width: 100%;\n    grid-template-columns: repeat(3, 1fr);\n    border-radius: 1rem;\n    background-color: var(--color-primary-3);\n    font-size: var(--default-font-small);\n\n    &__active {\n      background-color: var(--color-dark);\n      color: var(--color-white);\n      font-weight: 700;\n    }\n\n    & > * {\n      padding: 1rem 0;\n      text-align: center;\n      box-sizing: border-box;\n      cursor: pointer;\n\n      @media only screen and (max-width: $bp-600) {\n        text-align: center;\n        padding: 1rem;\n      }\n\n      &:hover {\n        background-color: var(--color-dark);\n        color: var(--color-white);\n        font-weight: 700;\n      }\n    }\n\n    & > :not(:last-child) {\n      border-right: 1px solid var(--color-primary);\n    }\n\n    & > :first-child {\n      border-radius: 1rem 0 0 1rem;\n    }\n\n    & > :last-child {\n      border-radius: 0 1rem 1rem 0;\n    }\n  }\n}\n\n// Transaction Date //\n\n.date {\n  background: var(--color-dark);\n  border-radius: 1rem;\n  padding: 1rem;\n  text-align: center;\n  font-weight: 700;\n  font-size: var(--default-font-small);\n  line-height: 1.7rem;\n  color: var(--color-white);\n  margin-top: 2rem;\n  margin-bottom: 2rem;\n}\n\n// Recent Transactions //\n\n.rt {\n  &__main {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  &__content {\n    width: 95%;\n    cursor: pointer;\n\n    & > :not(:last-child) {\n      margin-bottom: 3rem;\n    }\n  }\n}\n\n// Add Payment Type Styles //\n\n.paymentType {\n  display: flex;\n  flex-direction: row;\n  gap: 2.9rem;\n  margin-right: 2rem;\n  margin-bottom: 2rem;\n}\n\n.beside {\n  display: flex;\n  justify-content: space-between;\n  width: 38rem;\n}\n\n.successImg {\n  height: 19rem;\n}\n\n//Errors\n\n.error {\n  font-size: var(--default-font-small);\n  color: var(--color-error);\n  font-weight: 400;\n}\n\n.checks {\n  display: flex;\n  justify-content: space-between;\n  margin: 1rem 0 2rem 0;\n  gap: 7rem;\n  width: 40rem;\n\n  // &> :not(:last-child) {\n  // \tmargin-right: 1rem;\n  // }\n}\n\n.incomeTable {\n  margin-top: 2rem;\n\n  table {\n    width: 100%;\n    max-width: 100%;\n    border: none;\n    border-collapse: collapse;\n    box-sizing: border-box;\n    text-align: left;\n    font-size: var(--default-font-small);\n\n    th,\n    td {\n      padding: 2.2rem 0;\n    }\n\n    th {\n      font-weight: 700;\n    }\n\n    tr {\n      display: grid;\n      grid-template-columns: 1fr 2.5fr repeat(4, 1fr) 0.5fr;\n      padding: 0 1.5rem;\n\n      @media only screen and (max-width: $bp-600) {\n        grid-template-columns: 1.5fr 2.5fr 1fr;\n      }\n    }\n\n    tbody {\n      & > :not(:last-child) {\n        margin-bottom: 1.5rem;\n      }\n\n      tr {\n        background-color: var(--color-primary-3);\n        cursor: pointer;\n        border-radius: 1.3rem;\n\n        &:nth-child(even) {\n          background-color: var(--color-primary-7);\n        }\n\n        & > :nth-child(7) {\n          font-size: 3rem;\n          position: relative;\n\n          span {\n            font-size: 1.2rem;\n            width: fit-content;\n            background-color: rgba(0, 0, 0, 0.75);\n            color: var(--color-white);\n            position: absolute;\n            padding: 0.5rem;\n            left: -1.6rem;\n            border-radius: 0.5rem;\n            text-align: center;\n            opacity: 0;\n            cursor: pointer;\n\n            &:hover {\n              opacity: 1;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.expenseTable {\n  margin-top: 2rem;\n\n  table {\n    width: 100%;\n    // max-width: 100%;\n    border: none;\n    border-collapse: collapse;\n    box-sizing: border-box;\n    text-align: left;\n    font-size: var(--default-font-small);\n\n    th,\n    td {\n      padding: 2.2rem 0;\n    }\n\n    th {\n      font-weight: 700;\n    }\n\n    tr {\n      display: grid;\n      grid-template-columns: repeat(6, 1fr) 0.5fr;\n      padding: 0 3rem;\n\n      @media only screen and (max-width: $bp-600) {\n        grid-template-columns: 1.5fr 2fr 2fr;\n      }\n    }\n\n    tbody {\n      & > :not(:last-child) {\n        margin-bottom: 1.5rem;\n      }\n\n      tr {\n        background-color: var(--color-primary-3);\n        cursor: pointer;\n        border-radius: 1.3rem;\n\n        &:nth-child(even) {\n          background-color: var(--color-primary-7);\n        }\n\n        & > :nth-child(7) {\n          font-size: 3rem;\n          position: relative;\n\n          span {\n            font-size: 1.2rem;\n            width: fit-content;\n            background-color: rgba(0, 0, 0, 0.75);\n            color: var(--color-white);\n            position: absolute;\n            padding: 0.5rem;\n            left: -1.6rem;\n            border-radius: 0.5rem;\n            text-align: center;\n            opacity: 0;\n            cursor: pointer;\n\n            &:hover {\n              opacity: 1;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.expenseDebtTable {\n  margin-top: 2rem;\n\n  table {\n    width: 100%;\n    max-width: 100%;\n    border: none;\n    border-collapse: collapse;\n    box-sizing: border-box;\n    text-align: left;\n    font-size: var(--default-font-small);\n    position: relative;\n\n    th,\n    td {\n      padding: 2.2rem 0;\n    }\n\n    th {\n      font-weight: 700;\n    }\n\n    tr {\n      display: grid;\n      grid-template-columns: repeat(4, 1fr);\n      padding: 0 3rem;\n      align-items: center;\n    }\n\n    tbody {\n      & > :not(:last-child) {\n        margin-bottom: 1.5rem;\n      }\n\n      tr {\n        background-color: var(--color-primary-3);\n        cursor: pointer;\n        border-radius: 1.3rem;\n\n        &:nth-child(even) {\n          background-color: var(--color-primary-7);\n        }\n      }\n    }\n  }\n}\n\n.notPaid {\n  display: inline-flex;\n  justify-content: center;\n  line-height: 1;\n  font-size: 1rem;\n  border-radius: 1rem;\n  background-color: var(--color-error);\n  color: var(--color-white);\n  margin: 1.5rem 0;\n  width: 83%;\n  text-align: center;\n  padding: 1rem;\n}\n\n.partPaid {\n  display: inline-flex;\n  justify-content: center;\n  line-height: 1;\n  font-size: 1rem;\n  border-radius: 1rem;\n  background-color: var(--color-yellow);\n  color: var(--color-dark);\n  margin: 1.5rem 0;\n  width: 83%;\n  text-align: center;\n  padding: 1rem;\n}\n\n.paid {\n  display: inline-flex;\n  justify-content: center;\n  line-height: 1;\n  font-size: 1rem;\n  border-radius: 1rem;\n  background-color: var(--color-green);\n  color: var(--color-white);\n  margin-bottom: 2rem;\n  width: 83%;\n  position: relative;\n  top: 1rem;\n  padding: 1rem;\n}\n\n.alignRight {\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  font-size: var(--default-font-small);\n  color: var(--color-primary);\n  cursor: pointer;\n  font-weight: 700;\n  text-decoration: underline;\n}\n\n.tableButton {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  color: var(--color-white);\n  font-size: 2rem;\n  width: 34rem;\n  height: 5.7rem;\n  padding: 2rem;\n  background-color: var(--color-primary);\n  border-radius: 1rem;\n  cursor: pointer;\n  z-index: 1000;\n\n  &_active {\n    transform: rotate(180deg);\n    z-index: 10000;\n  }\n}\n\n.dropDown {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  background-color: var(--color-white);\n  font-size: 2rem;\n  box-sizing: border-box;\n  border-bottom: 1px solid var(--color-dark);\n  padding: 1rem;\n  width: 34rem;\n  cursor: pointer;\n  align-content: center;\n}\n\n.receipt {\n  &__list {\n    margin-top: 2rem;\n    display: flex;\n    position: relative;\n  }\n\n  &__beside {\n    display: flex;\n    justify-content: space-between;\n  }\n\n  &__checks {\n    display: flex;\n    justify-content: space-between;\n    margin: 1rem 0 2rem 0;\n  }\n}\n\n.summary {\n  width: 42rem;\n  margin-top: 2rem;\n\n  &__title {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  &__edit {\n    display: flex;\n    align-items: flex-end;\n    color: var(--color-dark);\n    font-size: var(--default-font-small);\n    cursor: pointer;\n\n    & > :last-child {\n      font-size: 3rem;\n      color: var(--color-primary);\n    }\n\n    &:hover,\n    &:focus {\n      color: var(--color-primary-4);\n      font-weight: 700;\n    }\n  }\n\n  &__line {\n    border-top: 1px solid var(--color-primary);\n    margin: 2rem 0;\n  }\n\n  &__beside {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  &__dates {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 2rem;\n\n    & > :not(:last-child) {\n      margin-right: 2rem;\n    }\n  }\n\n  &__details {\n    color: var(--color-primary);\n  }\n\n  &__total {\n    display: grid;\n    grid-template-columns: 1.3fr 1fr;\n    gap: 2rem;\n    margin-bottom: 1rem;\n  }\n\n  &__account {\n    display: grid;\n    grid-template-columns: 1.3fr 1fr;\n    gap: 1rem;\n    margin: 2rem 0;\n  }\n\n  &__button {\n    display: flex;\n    gap: 2rem;\n  }\n}\n\n.noRecord {\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 75.5%;\n  text-align: center;\n}\n\n//transaction new update\n\n.txFilterSection {\n  display: flex;\n  gap: 2rem;\n  margin-top: 2rem;\n}\n\n.txSelect {\n  width: 30rem;\n  font-size: var(--default-font-small);\n\n  &__title {\n    width: 100%;\n    font-weight: 700;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0.9rem 2.2rem;\n    background-color: var(--color-white);\n    border-radius: 1rem;\n    box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n    cursor: pointer;\n    color: var(--color-fash-primary-3);\n\n    &:hover {\n      color: var(--color-fash-primary-3);\n      background-color: var(--color-light-blue-2);\n    }\n\n    &__icon {\n      font-size: 2rem;\n\n      &__clicked {\n      }\n    }\n  }\n\n  &__content {\n    width: 100%;\n    background-color: var(--color-white);\n    border-radius: 1rem;\n    box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n    cursor: pointer;\n    padding: 0.9rem 0;\n    margin-top: 1rem;\n    display: flex;\n    flex-direction: column;\n    max-height: 20rem;\n    overflow-y: scroll;\n\n    span {\n      padding: 1rem 2.2rem;\n\n      &:hover,\n      &:active,\n      &:focus {\n        background-color: var(--color-light-blue-2);\n        color: var(--color-primary);\n        font-weight: 700;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `Transactions_main__0eWYA`,
	"main_nav": `Transactions_main_nav__TRDxv`,
	"main_nav_group": `Transactions_main_nav_group__8Po1l`,
	"main_nav_more": `Transactions_main_nav_more__HXbHd`,
	"main_nav_item": `Transactions_main_nav_item__C7pbQ`,
	"main_nav_item_active": `Transactions_main_nav_item_active__VecMV`,
	"searchInMiddle": `Transactions_searchInMiddle__c6yJF`,
	"recent": `Transactions_recent__+uJUo`,
	"recent__title": `Transactions_recent__title__tWoPF`,
	"recent__title__active": `Transactions_recent__title__active__WW6pA`,
	"date": `Transactions_date__AR2ZR`,
	"rt__main": `Transactions_rt__main__8h1hC`,
	"rt__content": `Transactions_rt__content__OylBj`,
	"paymentType": `Transactions_paymentType__konyh`,
	"beside": `Transactions_beside__sh6vD`,
	"successImg": `Transactions_successImg__ksTU1`,
	"error": `Transactions_error__NPbqG`,
	"checks": `Transactions_checks__mnsLT`,
	"incomeTable": `Transactions_incomeTable__kJPzn`,
	"expenseTable": `Transactions_expenseTable__EvhQv`,
	"expenseDebtTable": `Transactions_expenseDebtTable__d08Tl`,
	"notPaid": `Transactions_notPaid__h3MB5`,
	"partPaid": `Transactions_partPaid__YM64h`,
	"paid": `Transactions_paid__blUp+`,
	"alignRight": `Transactions_alignRight__kx--b`,
	"tableButton": `Transactions_tableButton__J36rR`,
	"tableButton_active": `Transactions_tableButton_active__M1PO2`,
	"dropDown": `Transactions_dropDown__+ng9P`,
	"receipt__list": `Transactions_receipt__list__T8YNV`,
	"receipt__beside": `Transactions_receipt__beside__VQWSk`,
	"receipt__checks": `Transactions_receipt__checks__a+nVp`,
	"summary": `Transactions_summary__lIo7k`,
	"summary__title": `Transactions_summary__title__xIQc2`,
	"summary__edit": `Transactions_summary__edit__8Eugp`,
	"summary__line": `Transactions_summary__line__Xjekf`,
	"summary__beside": `Transactions_summary__beside__9W2l6`,
	"summary__dates": `Transactions_summary__dates__QsV7m`,
	"summary__details": `Transactions_summary__details__tthZ8`,
	"summary__total": `Transactions_summary__total__NeHCw`,
	"summary__account": `Transactions_summary__account__vGqGS`,
	"summary__button": `Transactions_summary__button__fcWZo`,
	"noRecord": `Transactions_noRecord__5mGZ6`,
	"txFilterSection": `Transactions_txFilterSection__d2D-E`,
	"txSelect": `Transactions_txSelect__GjgEc`,
	"txSelect__title": `Transactions_txSelect__title__JV8pz`,
	"txSelect__title__icon": `Transactions_txSelect__title__icon__8P97+`,
	"txSelect__content": `Transactions_txSelect__content__Hx1rY`
};
export default ___CSS_LOADER_EXPORT___;
